/**
 * GBWaps 页面交互（Vue 挂载后调用，对应静态站 main.js）
 */

export function initAccordions(root = document) {
	const accordions = root.querySelectorAll('.accordion-item');

	accordions.forEach((item, index) => {
		const header = item.querySelector('.accordion-header');
		const content = item.querySelector('.accordion-content');
		if (!header || !content || header.dataset.bound === '1') return;

		header.dataset.bound = '1';
		header.addEventListener('click', () => {
			const group = item.parentElement;
			if (group && group.classList.contains('accordion-group')) {
				group.querySelectorAll('.accordion-item').forEach((other) => {
					if (other !== item) {
						other.classList.remove('active');
						const otherContent = other.querySelector('.accordion-content');
						if (otherContent) otherContent.style.maxHeight = '0';
					}
				});
			}

			item.classList.toggle('active');
			if (item.classList.contains('active')) {
				content.style.maxHeight = `${content.scrollHeight}px`;
			} else {
				content.style.maxHeight = '0';
			}
		});

		if (index === 0 && !item.classList.contains('no-auto-open')) {
			item.classList.add('active');
			content.style.maxHeight = `${content.scrollHeight}px`;
		}
	});
}

export function initSmoothScroll(root = document) {
	root.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		if (anchor.dataset.bound === '1') return;
		anchor.dataset.bound = '1';
		anchor.addEventListener('click', function onClick(e) {
			const href = this.getAttribute('href');
			if (!href || href === '#') return;
			const target = root.querySelector(href);
			if (target) {
				e.preventDefault();
				target.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		});
	});
}

export function lazyLoadImages(root = document) {
	const images = root.querySelectorAll('img[data-src]');
	if (!images.length || typeof IntersectionObserver === 'undefined') return;

	const imageObserver = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const img = entry.target;
				img.src = img.dataset.src;
				img.removeAttribute('data-src');
				observer.unobserve(img);
			}
		});
	});

	images.forEach((img) => imageObserver.observe(img));
}

export function initExternalLinks(root = document) {
	root.querySelectorAll('a[href^="http"]').forEach((link) => {
		if (!link.href.includes('gbwaps.com')) {
			link.setAttribute('target', '_blank');
			link.setAttribute('rel', 'noopener noreferrer');
		}
	});
}

/** 在布局挂载或路由切换后初始化内容区交互 */
export function initGbwapsPageUI(root = document) {
	initAccordions(root);
	initSmoothScroll(root);
	lazyLoadImages(root);
	initExternalLinks(root);
}
